<template>
  <div>
    <div class="app-container">
      <div
        :class="
          `dovemed-wrapper ${$route.path.includes('directories_map') ? '' : 'pt-5'} ${$route.path.includes('meetothers') ? 'meet-res' : ''} ${
            $route.path.includes('activity') || $route.path.includes('reviews') || $route.path.includes('resources') || $route.path.includes('treatments') ? 'm-mw-100' : ''
          }`
        "
        :style="{ 'min-width': $route.path.includes('directories_map') ? '100% !important' : 'auto' }"
      >
        <div class="row">
          <div class="col-md-4 col-lg-4 col-sm-12 col-xs-12 home-left-side" id="home-left-side" :style="{ display: $route.path.includes('directories_map') ? 'none' : 'block' }">
            <!-- main left bar -->
            <div class="hide-in-mobile dovemed-card home-tab pt-3 px-4 pb-4">
              <!-- NAME -->
              <div class="user-profile" @click="showProfile">
                <div class="d-flex align-items-center">
                  <div>
                    <a-avatar
                      :style="{ color: ' #ffffff !important', 'background-color': authUser.user.url ? '' : getAvatarColor(authUser.user.id) }"
                      :size="40"
                      class="text-capitalize font16 fw700"
                      :src="authUser.user ? authUser.user.url : ``"
                      alt="avatar"
                    >
                      {{ getAuthUserInitials() }}
                    </a-avatar>
                  </div>

                  <div class="text-left m-auto">
                    <div class="name text-capitalize">
                      {{
                        authUser.user.role === "doctor"
                          ? "Dr. " + (authUser.user.first_name ? authUser.user.first_name + " " + authUser.user.last_name : authUser.user.display_name)
                          : authUser.user.first_name
                          ? authUser.user.first_name + " " + authUser.user.last_name
                          : authUser.user.display_name
                      }}
                    </div>
                    <!-- <span v-if="authUser.user.role === 'hospital_administrator' || authUser.user.role === 'clinic_administrator'" class="admin-tag d-block"> Administrator </span> -->
                  </div>
                </div>
                <div class="d-flex align-items-center update-profile-tab" :style="{ color: getPrimaryColor(), 'font-size': '14px', 'font-weight': '400', 'line-height': '24px', 'min-width': '112px' }">
                  {{ authUser.user.role === "patient" || authUser.user.role === "caregiver" ? "Update My Profile" : "View My Story" }}
                </div>
              </div>
              <hr class="mt-0" />

              <router-link :to="{ name: 'ActivityHome' }">
                <font-awesome-icon size="2x" class="mr-2" style="transform: scale(0.7); width: 30px" :icon="[`${$route.path.includes('activity') ? 'fas' : 'fal'}`, 'window-maximize']" />
                Activity
              </router-link>

              <router-link :to="{ name: 'MyCircleStats' }" class="mycircle-tab">
                <font-awesome-icon size="2x" class="mr-2" style="transform: scale(0.7); width: 30px" :icon="[`${$route.path.includes('mycirclestats') ? 'fas' : 'fal'}`, 'draw-circle']" />
                MyCircle Stats
              </router-link>

              <router-link :to="{ name: 'MeetOthers' }" class="meet-others-tab">
                <font-awesome-icon size="2x" class="mr-2" style="transform: scale(0.7); width: 30px" :icon="[`${$route.path.includes('meetothers') ? 'fas' : 'fal'}`, 'user-plus']" />
                Meet Others
              </router-link>

              <router-link :to="{ name: 'MedicalDirectory' }" style="line-height: 24px" class="med-dir-tab">
                <font-awesome-icon size="2x" class="mr-2" style="transform: scale(0.7); width: 30px" :icon="[`${$route.path.includes('medicaldirectories') ? 'fas' : 'fal'}`, 'briefcase-medical']" />
                <div style="line-height: normal">
                  Medical Directory
                  <p class="font10 mb-0" style="color: inherit">(Physicians, Hospitals, Clinics, and more)</p>
                </div>
              </router-link>

              <router-link :to="{ name: 'MyDoveDirectory' }" style="line-height: 24px">
                <font-awesome-icon size="2x" class="mr-2" style="transform: scale(0.7); width: 30px" :icon="[`${$route.path.includes('mydovedirectory') ? 'fas' : 'fal'}`, 'book-open']" />
                <div style="line-height: normal">My Dove Directory</div>
              </router-link>

              <router-link :to="{ name: 'DoveMedRecommendedPage' }">
                <font-awesome-icon size="2x" class="mr-2" style="transform: scale(0.7); width: 30px" :icon="['fal', 'badge-check']" />
                DoveMed Recommended
              </router-link>

              <router-link :to="{ name: 'Recommended' }">
                <font-awesome-icon size="2x" class="mr-2" style="transform: scale(0.7); width: 30px" :icon="[`${$route.path.includes('recommendations') ? 'fas' : 'fal'}`, 'thumbs-up']" />
                Recommendations
              </router-link>

              <router-link :to="{ name: 'Reviews' }">
                <i :class="`${$route.path.includes('reviews') ? 'fa fa-star fa-2x mr-2' : 'fa fa-star-o fa-2x mr-2'}`" aria-hidden="true" style="transform: scale(0.7); width: 30px"></i>
                Reviews
              </router-link>

              <router-link :to="{ name: 'meetAdvocates', query: { type: 'others' } }">
                <font-awesome-icon size="2x" class="mr-2" style="transform: scale(0.7); width: 30px" :icon="[`${$route.path.includes('meetAdvocates') ? 'fas' : 'fal'}`, 'bullhorn']" />
                Meet Advocates
              </router-link>

              <router-link :to="{ name: 'ResourceList' }">
                <font-awesome-icon size="2x" class="mr-2" style="transform: scale(0.7); width: 30px" :icon="[`${$route.path.includes('resources') ? 'fas' : 'fal'}`, 'book-open']" />
                Resources
              </router-link>

              <a :href="`${SSO_BASE_URL}/ask-a-doctor/search?ordering=-recommended&tag=${currentCircleTag()}`" target="_blank" class="ml-1">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M10 10.9375C9.53125 10.9375 9.21875 11.2891 9.21875 11.7188C9.21875 12.1484 9.53125 12.5 10 12.5C10.4297 12.5 10.7812 12.1875 10.7812 11.7188C10.7812 11.2891 10.4297 10.9375 10 10.9375ZM17.5 0H2.5C1.09375 0 0 1.13281 0 2.5V13.7109C0 15.1562 1.09375 16.25 2.5 16.25H6.25V19.4922C6.25 19.8828 6.67969 20.0781 6.99219 19.8438L11.875 16.25H17.5C18.8672 16.25 20 15.1172 20 13.75V2.5C20 1.13281 18.8672 0 17.5 0ZM18.75 13.75C18.75 14.4531 18.1641 15 17.5 15H11.8359C11.5625 15 11.3281 15.1172 11.0938 15.2734L7.5 17.9688V15.625C7.5 15.3125 7.1875 15 6.875 15H2.5C1.79688 15 1.25 14.4531 1.25 13.75V2.5C1.25 1.83594 1.79688 1.25 2.5 1.25H17.5C18.1641 1.25 18.75 1.83594 18.75 2.5V13.75ZM10.8594 3.75H8.94531C7.8125 3.75 6.875 4.72656 6.875 5.85938C6.875 6.21094 7.14844 6.48438 7.5 6.48438C7.8125 6.48438 8.125 6.21094 8.125 5.85938C8.125 5.39062 8.47656 5 8.94531 5H10.8594C11.4062 5 11.875 5.46875 11.875 6.01562C11.875 6.40625 11.6406 6.75781 11.2891 6.95312L9.6875 7.77344C9.49219 7.89062 9.375 8.08594 9.375 8.32031V9.375C9.375 9.72656 9.64844 10 10 10C10.3125 10 10.625 9.72656 10.625 9.375V8.71094L11.875 8.04688C12.6172 7.65625 13.125 6.875 13.125 6.01562C13.125 4.76562 12.1094 3.75 10.8594 3.75Z"
                    fill="#0F1734"
                  />
                </svg>
                <span class="ml-3">Ask A Doctor</span>
              </a>

              <router-link :to="{ name: 'QA' }">
                <div :style="{ marginRight: '17px', marginLeft: '5px', stroke: `${$route.path.includes('qa') ? getPrimaryColor() : ''}` }">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M10 10.9375C9.53125 10.9375 9.21875 11.2891 9.21875 11.7188C9.21875 12.1484 9.53125 12.5 10 12.5C10.4297 12.5 10.7812 12.1875 10.7812 11.7188C10.7812 11.2891 10.4297 10.9375 10 10.9375ZM17.5 0H2.5C1.09375 0 0 1.13281 0 2.5V13.7109C0 15.1562 1.09375 16.25 2.5 16.25H6.25V19.4922C6.25 19.8828 6.67969 20.0781 6.99219 19.8438L11.875 16.25H17.5C18.8672 16.25 20 15.1172 20 13.75V2.5C20 1.13281 18.8672 0 17.5 0ZM18.75 13.75C18.75 14.4531 18.1641 15 17.5 15H11.8359C11.5625 15 11.3281 15.1172 11.0938 15.2734L7.5 17.9688V15.625C7.5 15.3125 7.1875 15 6.875 15H2.5C1.79688 15 1.25 14.4531 1.25 13.75V2.5C1.25 1.83594 1.79688 1.25 2.5 1.25H17.5C18.1641 1.25 18.75 1.83594 18.75 2.5V13.75ZM10.8594 3.75H8.94531C7.8125 3.75 6.875 4.72656 6.875 5.85938C6.875 6.21094 7.14844 6.48438 7.5 6.48438C7.8125 6.48438 8.125 6.21094 8.125 5.85938C8.125 5.39062 8.47656 5 8.94531 5H10.8594C11.4062 5 11.875 5.46875 11.875 6.01562C11.875 6.40625 11.6406 6.75781 11.2891 6.95312L9.6875 7.77344C9.49219 7.89062 9.375 8.08594 9.375 8.32031V9.375C9.375 9.72656 9.64844 10 10 10C10.3125 10 10.625 9.72656 10.625 9.375V8.71094L11.875 8.04688C12.6172 7.65625 13.125 6.875 13.125 6.01562C13.125 4.76562 12.1094 3.75 10.8594 3.75Z"
                      fill="#0F1734"
                    />
                  </svg>
                </div>
                Q&A
              </router-link>

              <router-link :to="{ name: 'Treatments', query: { type: 'all' } }" class="treatmentTab">
                <font-awesome-icon size="2x" class="mr-2" style="transform: scale(0.7); width: 30px" :icon="[`${$route.path.includes('treatments') ? 'fas' : 'fal'}`, 'pills']" />
                Treatments A-Z
              </router-link>

              <router-link :to="{ name: 'AboutCircle' }">
                <font-awesome-icon size="2x" class="mr-2" style="transform: scale(0.7); width: 30px" :icon="[`${$route.path.includes('aboutcircle') ? 'fas' : 'fal'}`, 'question-circle']" />
                About the Circle
              </router-link>

              <router-link :to="{ name: 'CirclesAll' }">
                <font-awesome-icon size="2x" class="mr-2" style="transform: scale(0.7); width: 30px" :icon="['fal', 'exchange-alt']" />
                Other Circles
              </router-link>

              <!-- update dovedaily -->
              <div class="update-dovedaily-tab">
                <div
                  class="d-flex flex-wrap align-items-center p-3 rounded font-white position-relative"
                  :style="{ 'background-color': getSecondaryColor() }"
                  v-if="this.authUser.user.role === 'patient' || this.authUser.user.role === 'caregiver'"
                >
                  <!-- v-if="(this.authUser.user.role === 'patient' || this.authUser.user.role === 'caregiver') && !isDateToday(new Date(dovedailyUpdatedAt))" -->
                  <font-awesome-icon :icon="['fas', 'calendar-edit']" class="font20 font-white pr-0 mr-3" />
                  <div class="flex-grow-1">
                    <p class="mb-0 fw700 font-white">Update Your DoveDaily</p>
                    <p v-if="dovedailyUpdatedAt" class="mb-0 font12 font-white">Last updated: {{ new Date(dovedailyUpdatedAt).toDateString().substring(4) }}</p>
                  </div>
                  <div
                    v-if="authUser.user.tutorial_seen"
                    class="ml-4 rounded py-2 px-3 font12 fw700 cp"
                    :style="{ 'background-color': getPrimaryColor() }"
                    @click="() => $router.push({ name: 'UpdateDoveDaily' })"
                  >
                    Update
                  </div>
                </div>
              </div>
            </div>

            <!-- recently trending -->
            <div class="dovemed-card hide-in-mobile" v-if="recentlyTrending.length">
              <p class="title">Recently Trending</p>
              <div class="post-head" v-for="(trending, index) in recentlyTrending" :key="index">
                <div class="title cp" @click="viewProfile(trending)">
                  <a-avatar
                    :style="{ color: ' #ffffff !important', 'background-color': trending.url ? '' : getAvatarColor(trending.id) }"
                    :size="70"
                    :src="trending.url"
                    class="post-list-image text-capitalize my-auto"
                    alt="avatar"
                  >
                    {{ getInitials(trending) }}
                  </a-avatar>
                </div>
                <div class="w-100 my-auto" :style="{ overflow: 'auto' }">
                  <p class="name text-truncate text-capitalize cp" @click="viewProfile(trending)">
                    {{ getDisplayName(trending) }}
                  </p>
                  <p :style="{ color: '#777' }" v-if="trending.location && trending.location[0].city" class="location">
                    <i class="fa fa-map-marker" aria-hidden="true"></i>
                    {{ trending.location[0].city }},
                    {{ trending.location[0].state }}
                  </p>
                  <!-- <p class="hyper-link" :style="{ color: getPrimaryColor() }">
                      {{ trending.circle_member }} circle members
                    </p> -->
                </div>
              </div>
              <!-- <hr v-if="index !== recentlyTrending.length - 1" /> -->
              <!-- </div> -->
            </div>

            <!-- recently joined members -->
            <div class="dovemed-card hide-in-mobile" v-if="recentlyJoined.length">
              <p class="title">Recently Joined Members</p>
              <div class="post-head" v-for="(joined, index) in recentlyJoined" :key="index">
                <div class="title cp" @click="viewProfile(joined)">
                  <a-avatar
                    :style="{ color: ' #ffffff !important', 'background-color': joined.url ? '' : getAvatarColor(joined.id) }"
                    :size="70"
                    :src="joined.url"
                    class="post-list-image text-capitalize my-auto"
                    alt="avatar"
                  >
                    {{ getInitials(joined) }}
                  </a-avatar>
                </div>
                <div class="overflow-auto my-auto">
                  <p class="name text-truncate text-capitalize cp" @click="viewProfile(joined)">
                    {{ getDisplayName(joined) }}
                  </p>
                  <p :style="{ color: '#777' }" v-if="joined.location && joined.location[0].city" class="location">
                    <i class="fa fa-map-marker" aria-hidden="true"></i>
                    {{ joined.location[0].city }},
                    {{ joined.location[0].state }}
                  </p>
                  <!-- <p class="hyper-link" :style="{ color: getPrimaryColor() }">
                      {{ joined.circle_member }} circle members
                    </p> -->
                </div>
              </div>
              <!-- <hr v-if="index !== recentlyJoined.length - 1" /> -->
              <!-- </div> -->
            </div>

            <!-- recently reviewed -->
            <div class="dovemed-card hide-in-mobile" v-if="recentlyReviewed.length">
              <p class="title">Recently Reviewed</p>
              <div class="post-head" v-for="(reviewed, index) in recentlyReviewed" :key="index">
                <div
                  class="title cp"
                  @click="
                    !reviewed.reviewee_mycircle_id
                      ? routeProfile(reviewed.reviewee, reviewed.reviewee_role, reviewed.reviewee_id)
                      : viewProfile({ role: reviewed.reviewee_role, id: reviewed.reviewee_mycircle_id })
                  "
                >
                  <a
                    @click="
                      !reviewed.reviewee_mycircle_id
                        ? routeProfile(reviewed.reviewee, reviewed.reviewee_role, reviewed.reviewee_id)
                        : viewProfile({ role: reviewed.reviewee_role, id: reviewed.reviewee_mycircle_id })
                    "
                  >
                    <a-avatar
                      :style="{ color: ' #ffffff !important', 'background-color': reviewed.reviewee.url ? '' : getAvatarColor(reviewed.id) }"
                      :size="70"
                      :src="reviewed.reviewee.url"
                      class="post-list-image text-capitalize my-auto"
                    >
                      {{ getInitials({ ...reviewed.reviewee, role: reviewed.reviewee_role }) }}
                    </a-avatar>
                  </a>
                </div>
                <div class="overflow-auto my-auto">
                  <p
                    class="name text-truncate text-capitalize cp"
                    @click="
                      !reviewed.reviewee_mycircle_id
                        ? routeProfile(reviewed.reviewee, reviewed.reviewee_role, reviewed.reviewee_id)
                        : viewProfile({ role: reviewed.reviewee_role, id: reviewed.reviewee_mycircle_id })
                    "
                  >
                    {{ getDisplayName({ ...reviewed.reviewee, role: reviewed.reviewee_role }) }}
                  </p>
                  <p :style="{ color: '#777' }" v-if="reviewed.reviewee.location ? reviewed.reviewee.location[0].city : reviewed.reviewee.address && reviewed.reviewee.address.city" class="location">
                    <i class="fa fa-map-marker" aria-hidden="true"></i>
                    {{ reviewed.reviewee.location ? reviewed.reviewee.location[0].city : reviewed.reviewee.address.city }},
                    {{ reviewed.reviewee.location ? reviewed.reviewee.location[0].state : reviewed.reviewee.address.state }}
                  </p>
                </div>
              </div>
              <!-- <div :style="{ color: getPrimaryColor() }" class="br8 font14 fw700 bg-gray100 w-100 text-center cp" v-if="recentlyReviewed.length > 3">View More</div> -->
            </div>

            <!-- need a hand -->
            <div class="dovemed-card contact-card pb-4 hide-in-mobile">
              <div class="top">
                <div>
                  <font-awesome-icon class="mr-2" :style="{ color: getPrimaryColor(), 'font-size': '40px' }" :icon="['fas', 'question-circle']" />
                </div>
                <div class="text">Need a Hand?</div>
                <!-- <div
                  class="beta-version "
                  :style="{ background: getPrimaryColor() }"
                >
                  Beta
                </div> -->
              </div>
              <div class="mid">
                <div class="description">
                  You are using MyCircles version. We are continuously enhancing the product, if you’re stuck or have a question, check out our
                  <a :href="`${SSO_BASE_URL}/help-center`" target="_blank" class="hyper-link" :style="{ color: getPrimaryColor() }"> Help Center</a>. If you still have any queries or want to make a
                  suggestion, please reach out to us. Your inputs are valuable to us.
                </div>
                <!-- <div class="info">
                  Please keep in mind that this is a beta version.
                </div> -->
              </div>
              <div class="bottom">
                <a-button @click="() => $router.push({ name: 'Support' })" :style="{ background: getPrimaryColor() }" class="dovemed-button font-white primary-button"> Contact Support </a-button>
              </div>
              <!-- @click="openSupportModal"   OLD MODAL -->
            </div>

            <!-- crisis helpline -->
            <div class="dovemed-card contact-card hide-in-mobile">
              <div class="top">
                <div class="circle-phone" :style="{ background: getPrimaryColor() }">
                  <!-- <svg
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fas"
                    data-icon="phone-volume"
                    class="svg-inline--fa fa-phone-volume"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                  >
                    <path
                      fill="currentColor"
                      d="M284.6 181.9c-10.28-8.344-25.41-6.875-33.75 3.406C242.4 195.6 243.9 210.7 254.2 219.1c11.31 9.25 17.81 22.69 17.81 36.87c0 14.19-6.5 27.62-17.81 36.87c-10.28 8.406-11.78 23.53-3.375 33.78c4.719 5.812 11.62 8.812 18.56 8.812c5.344 0 10.75-1.781 15.19-5.406c22.53-18.44 35.44-45.4 35.44-74.05S307.1 200.4 284.6 181.9zM345.1 107.1c-10.22-8.344-25.34-6.907-33.78 3.343c-8.406 10.25-6.906 25.37 3.344 33.78c33.88 27.78 53.31 68.18 53.31 110.9s-19.44 83.09-53.31 110.9c-10.25 8.406-11.75 23.53-3.344 33.78c4.75 5.781 11.62 8.781 18.56 8.781c5.375 0 10.75-1.781 15.22-5.438C390.2 367.1 416 313.1 416 255.1S390.2 144.9 345.1 107.1zM406.4 33.15c-10.22-8.344-25.34-6.875-33.78 3.344c-8.406 10.25-6.906 25.37 3.344 33.78C431.9 116.1 464 183.8 464 255.1s-32.09 139.9-88.06 185.7c-10.25 8.406-11.75 23.53-3.344 33.78c4.75 5.781 11.62 8.781 18.56 8.781c5.375 0 10.75-1.781 15.22-5.438C473.5 423.8 512 342.6 512 255.1S473.5 88.15 406.4 33.15zM151.3 174.6C161.1 175.6 172.1 169.5 176 159.6l33.75-84.38C214 64.35 209.1 51.1 200.2 45.86l-67.47-42.17C123.2-2.289 110.9-.8945 102.9 7.08C-34.32 144.3-34.31 367.7 102.9 504.9c7.982 7.984 20.22 9.379 29.75 3.402l67.48-42.19c9.775-6.104 13.9-18.47 9.598-29.3L176 352.5c-3.945-9.963-14.14-16.11-24.73-14.97l-53.24 5.314C78.89 286.7 78.89 225.4 98.06 169.3L151.3 174.6z"
                    ></path>
                  </svg> -->
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="1em"
                    viewBox="0 0 512 512"
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fas"
                    data-icon="phone-volume"
                    class="svg-inline--fa fa-phone-volume"
                    role="img"
                  >
                    <path
                      fill="currentColor"
                      d="M280 0C408.1 0 512 103.9 512 232c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-101.6-82.4-184-184-184c-13.3 0-24-10.7-24-24s10.7-24 24-24zm8 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32-72c0-13.3 10.7-24 24-24c75.1 0 136 60.9 136 136c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6-39.4-88-88-88c-13.3 0-24-10.7-24-24zM117.5 1.4c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L144 207.3c33.3 70.4 90.3 127.4 160.7 160.7L345 318.7c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C481.8 499.9 466 512 448 512C200.6 512 0 311.4 0 64C0 46 12.1 30.2 29.5 25.4l88-24z"
                    />
                  </svg>
                </div>
                <div class="text ml-2">Crisis Help Info</div>
              </div>
              <div class="mid">
                <div class="description">
                  In case of an emergency or if you need immediate help, please visit our Crisis center.
                </div>
              </div>
              <div class="bottom">
                <a-button @click="handleCrisisHelpline" :style="{ background: getPrimaryColor() }" class="dovemed-button font-white primary-button ant-btn">Click Here</a-button>
              </div>
            </div>

            <div class="leftFooter hide-in-mobile">
              <a :href="`${SSO_BASE_URL}/about-us/`" target="_blank"> About </a>
              •
              <a :href="`${SSO_BASE_URL}/help-center`" target="_blank"> Help </a>
              •
              <a :href="`${SSO_BASE_URL}/help-center/faq/mycircles-privacy-policy`" target="_blank"> Privacy </a>
              •
              <a :href="`${SSO_BASE_URL}/help-center/faq/mycircles-terms-of-use`" target="_blank"> Terms </a>
              •
              <a :href="`${SSO_BASE_URL}/help-center/faq/mycircles-community-guidelines`" target="_blank"> Community Guidelines </a>
              •
              <a :href="`${SSO_BASE_URL}/advertise-with-us/`" target="_blank"> Advertising </a>
              •
              <a :href="`${SSO_BASE_URL}/mycircles/contact-us`" target="_blank"> Contact Us </a>
              <p>© DoveMed {{ moment().year() }}</p>
            </div>
          </div>

          <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 home-right-side" :style="{ 'min-width': $route.path.includes('directories_map') ? '100% !important' : 'auto' }" id="home-right-side">
            <router-view></router-view>
          </div>
        </div>
      </div>
    </div>
    <ContactSupportModal ref="contactSupportModal" />
  </div>
</template>

<script>
import ContactSupportModal from "../Modals/contactSupportModal.vue"
import { RepositoryFactory } from "../../repositories/RepositoryFactory"
import { library } from "@fortawesome/fontawesome-svg-core"
import { faQuestionCircle, faStar, faDrawCircle, faPills, faBullhorn, faUserPlus, faUserMd, faHospitalAlt, faHospital, faHospitalSymbol } from "@fortawesome/pro-solid-svg-icons"
import { faThumbsUp, faBookOpen, faBadgeCheck } from "@fortawesome/pro-light-svg-icons"
import { responsiveHelper } from "../login/utils/responsive-helper"
import moment from "moment"
import { mapGetters } from "vuex"
import Driver from "driver.js"
import "driver.js/dist/driver.min.css"

library.add(faQuestionCircle, faThumbsUp, faPills, faStar, faDrawCircle, faBullhorn, faUserPlus, faUserMd, faHospitalAlt, faHospital, faHospitalSymbol, faBookOpen, faBadgeCheck)
const UserRepository = RepositoryFactory.get("user")
const AppRepository = RepositoryFactory.get("app")

export default {
  name: "Home",
  data() {
    return { recentlyTrending: [], recentlyJoined: [], recentlyReviewed: [], isMobile: responsiveHelper.isMobileDevice(), dovedailyUpdatedAt: null, tutCount: 0 }
  },
  components: { ContactSupportModal },
  computed: {
    SSO_BASE_URL: () => process.env.SSO_BASE_URL,
    ...mapGetters({ showTutorial: "User/showTutorial" }),
  },
  async created() {
    this.getRecentlyTrending()
    this.getRecentlyJoined()
    this.getRecentlyReviewed()
    // console.log("1. (created) Home.vue -> authUser.user:", this.authUser.user);
    this.authUser.user.first_name = this.authUser.user.display_name.split(" ")[0]
    this.authUser.user.last_name = this.authUser.user.display_name
      .split(" ")
      .slice(1)
      .join(" ")
    console.log("2. (created) Home.vue -> authUser.user:", this.authUser.user)
    if (this.authUser.user.role === "patient" || this.authUser.user.role === "caregiver") {
      const response = await UserRepository.getDovedaily(this.currentCircle.id)
      this.dovedailyUpdatedAt = response.data.data[0] && response.data.data[0].last_updated_at
      // console.log("Home -> dovedailyUpdatedAt ->", this.dovedailyUpdatedAt)
    }
  },
  mounted() {
    console.warn("Home mounted")
    this.updateColor()
    // this.temp()
    const htmlTag = document.querySelector("html")
    if (htmlTag) {
      htmlTag.style.setProperty("--S900C", this.getSecondaryColor().split(" ")[0])
      htmlTag.style.setProperty("--P500C", this.getPrimaryColor().split(" ")[0])
    }
  },
  updated() {
    console.warn("Home updated")
    this.updateColor()
    if (this.$route.path.includes("treatments")) {
      setTimeout(() => {
        document.getElementsByClassName("treatmentTab")[0].setAttribute(
          "style",
          ` color: ${this.currentCircle.color_code} !important;
            background-color: ${this.getPrimary50Color()}`
        )
      }, 200)
    }
  },
  watch: {
    showTutorial(v) {
      console.log("showTutorial changed")
      if (v) {
        document.getElementsByTagName("body")[0].setAttribute("style", "height: auto")
        this.temp()
      }
    },
    tutCount: {
      handler(v) {
        console.log("tutCount changed to:", v)
        // const popover = document.querySelector(".scoped-class")
        // console.log({ popover })
        // if (popover) {
        //   console.log("this.getSecondaryColor()", this.getSecondaryColor().split(" ")[0])
        //   console.log("this.getPrimaryColor()", this.getPrimaryColor().split(" ")[0])
        //   popover.style.setProperty("--S900C", this.getSecondaryColor().split(" ")[0])
        //   popover.style.setProperty("--P500C", this.getPrimaryColor().split(" ")[0])
        // }
        // const footer = document.querySelector(".driver-popover-footer")
        // console.log({ footer })
        // if (footer) {
        //   const newElem = document.createElement("div")
        //   newElem.innerText = `${v}/${"5"}`
        //   newElem.classList.add("tut-number")
        //   console.log("footer.firstChild:", footer.firstChild)
        //   footer.insertBefore(newElem, footer.firstChild)
        // }
        setTimeout(() => {
          console.log("setTimeout running for", v)
          switch (v) {
            case 1:
              // const popover1 = document.querySelector(".step-1")
              // if (popover1) {
              //   popover1.style.setProperty("--S900C", this.getSecondaryColor().split(" ")[0])
              //   popover1.style.setProperty("--P500C", this.getPrimaryColor().split(" ")[0])
              // }
              const backBtn = document.querySelector(".driver-prev-btn")
              if (backBtn) {
                backBtn.style.display = "none"
              }
              // remove back button
              break
            case 2:
              // const popover2 = document.querySelector(".step-2")
              // if (popover2) {
              //   popover2.style.setProperty("--S900C", this.getSecondaryColor().split(" ")[0])
              //   popover2.style.setProperty("--P500C", this.getPrimaryColor().split(" ")[0])
              // }
              break
            case 3:
              // const popover3 = document.querySelector(".step-3")
              // if (popover3) {
              //   popover3.style.setProperty("--S900C", this.getSecondaryColor().split(" ")[0])
              //   popover3.style.setProperty("--P500C", this.getPrimaryColor().split(" ")[0])
              // }
              break
            case 4:
              // const popover4 = document.querySelector(".step-4")
              // if (popover4) {
              //   popover4.style.setProperty("--S900C", this.getSecondaryColor().split(" ")[0])
              //   popover4.style.setProperty("--P500C", this.getPrimaryColor().split(" ")[0])
              // }
              break
            case 5:
              // const popover5 = document.querySelector(".step-5")
              // if (popover5) {
              //   popover5.style.setProperty("--S900C", this.getSecondaryColor().split(" ")[0])
              //   popover5.style.setProperty("--P500C", this.getPrimaryColor().split(" ")[0])
              // }
              break
          }
          // if (v) {
          //   const prevTutNum = document.querySelector(".tut-number")
          //   if (prevTutNum) {
          //     prevTutNum.style.display = "none"
          //   }
          //   const footer = document.querySelector(".driver-popover-footer")
          //   console.log({ footer })
          //   if (footer) {
          //     const newElem = document.createElement("div")
          //     newElem.innerText = `${v}/${"5"}`
          //     newElem.classList.add("tut-number")
          //     footer.insertBefore(newElem, footer.firstChild)
          //   }
          // }
        }, 100)
      },
      immediate: true,
    },
  },
  methods: {
    currentCircleTag() {
      if(this.currentCircle.circle_hashtag){
        return this.currentCircle.circle_hashtag.toLowerCase();
      }
      return this.currentCircle.condition_type
        .toLowerCase()
        .replace("circle", "")
        .replace("my", "")
        .trim()
        .replace(/-/g, "")
        .replace(/ /g, "")
        .replace(/’/g, "")
        .replace(/'/g, "")
        .substring(0, 33)
    },
    temp() {
      // this.tutCount = 1
      var steps = [
        {
          element: this.$el.querySelector(".update-profile-tab"),
          popover: {
            className: "step-1",
            title: "Update your profile",
            description:
              "Updating your profile with relevant information about yourself and your specific condition, including symptoms and treatments, will help others connect and interact with you better.",
          },
        },
        {
          element: this.$el.querySelector(".update-dovedaily-tab"),
          popover: {
            className: "step-2",
            position: "top",
            title: "Update Your DoveDaily",
            description:
              "DoveDaily is a feature that you can sync with any health & fitness App you are using. It can also help you keep track of your moods, treatment goals, and progress, including medication effectiveness.",
          },
        },
        {
          element: this.$el.querySelector(".meet-others-tab"),
          popover: {
            className: "step-3",
            title: "Connect with other people",
            description:
              "Adding people to your circles can help you relate better with others, share your personal experiences, and connect meaningfully with a community that supports those with chronic conditions.",
          },
        },
        {
          element: this.$el.querySelector(".mycircle-tab"),
          popover: {
            className: "step-4",
            title: "Create your circle",
            description:
              "You can create your own circles based on similarities such as condition subtype, treatment regimen, or activity participation. You may also create circles based on your geographical region.",
          },
        },
        {
          element: this.$el.querySelector(".med-dir-tab"),
          popover: {
            className: "step-5",
            title: "Review providers or medical institutions",
            description:
              "You may rate and review healthcare providers and institutions based on your experiences and interactions with them, which can help them address any concerns that you may be having.",
          },
        },
      ]
      if (this.authUser.user.role === "patient" || this.authUser.user.role === "caregiver") {
      } else {
        steps.splice(1, 1)
      }
      const driverObj = new Driver({
        className: "scoped-class",
        prevBtnText: "Back",
        nextBtnText: "Next",
        doneBtnText: "Done",
        allowClose: false,
        overlayClickNext: false,
        keyboardControl: false,
        onPrevious: Element => {
          this.tutCount = this.tutCount - 1
        },

        onNext: Element => {
          // console.log("next")

          // const popover = document.querySelector(".scoped-class")
          // console.log({ popover })
          // if (popover) {
          //   popover.style.setProperty("--S900C", this.getSecondaryColor().split(" ")[0])
          //   popover.style.setProperty("--P500C", this.getPrimaryColor().split(" ")[0])
          // }
          // const footer = document.querySelector(".driver-popover-footer")
          // console.log({ footer })
          // if (footer) {
          //   const newElem = document.createElement("div")
          //   newElem.innerText = `${count}/${steps.length}`
          //   newElem.classList.add("tut-number")
          //   footer.insertBefore(newElem, footer.firstChild)
          // }

          if (Element.node.className.includes("med-dir-tab")) {
            // console.log("done clicked")
            document.getElementsByTagName("body")[0].setAttribute("style", "height: 100%")
            this.$store.commit("User/setTutorialStep", false)
            UserRepository.editUserDetails(this.authUser.user.id, this.currentCircle.id, this.authUser.user.role, { tutorial_seen: true }).then(res => {
              this.authUser.user.tutorial_seen = true
            })
          }
        },
        onHighlightStarted: Element => {
          // console.log("highlight started")
          // const popover = document.querySelector(".scoped-class")
          // console.log({ popover })
          // if (popover) {
          //   popover.style.setProperty("--S900C", this.getSecondaryColor().split(" ")[0])
          //   popover.style.setProperty("--P500C", this.getPrimaryColor().split(" ")[0])
          // }
          // const footer = document.querySelector(".driver-popover-footer")
          // console.log({ footer })
          // if (footer) {
          //   const newElem = document.createElement("div")
          //   newElem.innerText = `${count}/${steps.length}`
          //   newElem.classList.add("tut-number")
          //   footer.insertBefore(newElem, footer.firstChild)
          // }
        },
        onHighlighted: Element => {
          // console.log("highlighted")

          this.tutCount = this.tutCount + 1

          // const popover = document.querySelector(".scoped-class")
          // console.log({ popover })
          // if (popover) {
          //   popover.style.setProperty("--S900C", this.getSecondaryColor().split(" ")[0])
          //   popover.style.setProperty("--P500C", this.getPrimaryColor().split(" ")[0])
          // }
          // const footer = document.querySelector(".driver-popover-footer")
          // console.log({ footer })
          // if (footer) {
          //   const newElem = document.createElement("div")
          //   newElem.innerText = `${count}/${steps.length}`
          //   newElem.classList.add("tut-number")
          //   footer.insertBefore(newElem, footer.firstChild)
          // }
        },
      })
      driverObj.defineSteps(steps)
      driverObj.start()
    },
    viewProfile(user) {
      this.loading = true
      if (user.id === this.authUser.user.id && user.role === this.authUser.user.role) {
        this.routeToAuthProfile(this.authUser.user.role)
      } else {
        UserRepository.getOtherUserProfile(user, this.currentCircle.id)
          .then(res => {
            const data = {
              ...res.data.data.user_info,
              on_circle: res.data.data.on_circle,
              request_to_add: res.data.data.request_to_add,
              no_of_members: res.data.data.no_of_members,
              recommendations: res.data.data.no_of_recommendations,
              recommend: res.data.data.recommend,
              overall_rating: res.data.data.overall_rating ? res.data.data.overall_rating : res.data.data.rating,
              inPersonReview: res.data.data.in_person_visit,
              onlineReview: res.data.data.online_tele_medicine,
              myCirclesReview: res.data.data.my_circle,
            }
            this.$store.commit("User/setViewUser", { data })
            switch (user.role) {
              case "doctor":
              case "physician":
                this.$router.push({ name: "ViewDoctorUpdates", params: { id: user.id } })
                break
              case "hcp":
              case "ohcp":
              case "ahcp":
              case "other":
                this.$router.push({ name: "ViewHcpUpdates", params: { id: user.id } })
                break
              case "clinic_administrator":
                this.$router.push({ name: "ViewClinicAbout", params: { id: user.id } })
                break
              case "hospital_administrator":
                this.$router.push({ name: "ViewHos_adminAbout", params: { id: user.id } })
                break
              case "nfp":
                this.$router.push({ name: "ViewNfpAbout", params: { id: user.id } })
                break
              case "patient":
                this.$router.push({ name: "ViewPatientUpdates", params: { id: user.id } })
                break
              case "caregiver":
                this.$router.push({ name: "ViewPatientUpdates", params: { id: user.id, role: "caregiver" } })
                break
              case "advocate":
                this.$router.push({ name: "ViewAdvocateAbout", params: { id: user.id } })
                break
              case "hospital":
                this.$router.push({ name: "HospViewAbout", params: { id: user.id } })
                break
              case "clinic":
                this.$router.push({ name: "ClinicViewAbout", params: { id: user.id } })
                break
              case "nfp_administrator":
                this.$router.push({ name: "ViewNfpAdminAbout", params: { id: user.id } })
                break
              default:
                break
            }
          })
          .catch(err => {})
      }
    },
    routeProfile(record, reviewee_role, reviewee_id) {
      this.loading = true
      let info = {}
      info = record
      if (!info.hasOwnProperty("role")) {
        info["role"] = reviewee_role
      }
      switch (info.role) {
        case "physician":
        case "providers":
        case "doctor":
          this.viewEntityProfile({
            ...info,
            role: "doctor",
            id: reviewee_id,
          })
          break
        case "other":
        case "hcp":
        case "hcp_administrator":
          this.viewEntityProfile({ ...info, role: "hcp", id: reviewee_id })
          break
        case "hospital":
        case "hospital_administrator":
          this.viewEntityProfile({ ...info, role: "hospital", id: reviewee_id })
          break
        case "clinic":
        case "clinic_administrator":
          this.viewEntityProfile({ ...info, role: "clinic", id: reviewee_id })
          break
        case "nfp":
        case "nfp_administrator":
          this.viewEntityProfile({ ...info, role: "nfp", id: reviewee_id })
          break
        case "Business":
          break
      }
    },
    getInitialsFromName(name) {
      const f = name.split(" ")[0] ? name.split(" ")[0][0] : "D"
      const l = name
        .split(" ")
        .slice(1)
        .join(" ")
        ? name
            .split(" ")
            .slice(1)
            .join(" ")[0]
        : ""
      return f.toUpperCase() + l.toUpperCase()
    },
    getInitials(user) {
      switch (user.role) {
        case "hospital_administrator":
        case "hospital":
          return this.getInitialsFromName(user.display_name || user.hospital_name || "H")
        case "clinic_administrator":
        case "clinic":
          return this.getInitialsFromName(user.display_name || user.clinic_name || "C")
        case "nfp_administrator":
        case "nfp":
          return this.getInitialsFromName(user.display_name || user.nfp_name || "N")
        case "doctor":
        case "physician":
        case "hcp":
        case "ohcp":
          return this.getInitialsFromName(user.display_name || user.first_name || "D")
        // return (user.first_name ? user.first_name[0].toUpperCase() : "Dr.") + (user.last_name ? user.last_name[0].toUpperCase() : "")
        default:
          return this.getInitialsFromName(user.display_name || "D")
      }
    },
    getDisplayName(user) {
      switch (user.role) {
        case "hospital_administrator":
        case "hospital":
          return user.display_name || user.hospital_name || "H"
        case "clinic_administrator":
        case "clinic":
          return user.display_name || user.clinic_name || "C"
        case "nfp_administrator":
        case "nfp":
          return user.display_name || user.nfp_name || "N"
        case "doctor":
        case "physician":
        case "hcp":
        case "ohcp":
          // return user.display_name || "Dr."
          return user.display_name ? user.display_name : user.first_name ? user.first_name + " " + (user.last_name || "") : "Dr."
        default:
          return user.display_name || "~No Name~"
      }
    },
    handleCrisisHelpline() {
      this.$router.push({ name: "CrisisHelpline" })
    },
    openSupportModal() {
      this.$refs.contactSupportModal.show()
    },

    /**
     * Get recently trending
     */
    getRecentlyTrending() {
      AppRepository.getRecentlyTrending(this.currentCircle)
        .then(res => {
          this.recentlyTrending = res.data.data
        })
        .catch(err => {})
    },

    /**
     * Get recently joined
     */
    getRecentlyJoined() {
      AppRepository.getRecentlyJoined(this.currentCircle)
        .then(res => {
          this.recentlyJoined = res.data.data
        })
        .catch(err => {})
    },

    /**
     * Get recently reviewed
     */
    getRecentlyReviewed() {
      AppRepository.getRecentlyReviewed(this.currentCircle)
        .then(res => {
          this.recentlyReviewed = res.data.data.filter(rev => typeof rev.reviewee !== "string")
        })
        .catch(err => {})
    },

    showProfile() {
      const profileType = this.authUser.user.role

      switch (profileType) {
        case "patient":
          this.$router.push({ name: "PatientUpdates" })
          break
        case "caregiver":
          this.$router.push({ name: "CaregiverUpdates" })
          break
        case "advocate":
          this.$router.push({ name: "AdvocateUpdates" })
          break
        case "hospital_administrator":
          this.$router.push({ name: "HosUpdates" })
          break
        case "clinic_administrator":
          this.$router.push({ name: "ClinicUpdates" })
          break
        case "doctor":
          this.$router.push({ name: "DocUpdates" })
          break
        case "hcp":
          this.$router.push({ name: "HcpAbout" })
          break
        case "nfp_administrator":
          this.$router.push({ name: "NFPAbout" })
          break
        case "clinic_profile":
          this.$router.push({ name: "Clinic_Profile" })
          break
        default:
          this.$router.push({ path: `profile/${profileType}/updates` })
          break
      }
    },

    updateColor() {
      console.log("Home - updateColor")
      this.$el.querySelectorAll("a").forEach(elem => {
        if (elem.classList.contains("router-link-active")) {
          elem.removeAttribute("style")
          elem.setAttribute(
            "style",
            ` color: ${this.currentCircle.color_code} !important;
            background-color: ${this.getPrimary50Color()}`
          )
        } else {
          if (elem.hasAttribute("style")) {
            elem.removeAttribute("style")
          }
        }
      })
      // if (screen.width <= 600) {
      // console.log(screen.width);
      // setTimeout(() => {
      // console.log("HOME scrolling...");
      // const right = document.getElementById("home-right-side");
      // const left = document.getElementById("home-left-side");
      // console.log("left", left);
      // console.log("right", right);
      // const rightC = document.getElementsByClassName("home-right-side");
      // const leftC = document.getElementsByClassName("home-left-side");
      // console.log("leftC", leftC[0].offSetHeight);
      // console.log("rightC", rightC);
      // window.scrollTo(0, leftC[0].offSetHeight);
      // rightC[0].scrollTop = 0;
      // leftC[0].scrollTop = leftC[0].scrollHeight;
      // document
      //   .getElementsByClassName("home-right-side")
      //   .item(0)
      //   .scrollIntoView(true);
      // }, 200);
      // }
    },

    /**
     * Active Class on navigation links
     */
    // setActiveLinkNav () {
    //   document.querySelector('.router-link-exact-active').setAttribute('style', `color: ${this.getPrimaryColor()} !important`)
    // }
  },
}
</script>

<style lang="scss" scoped>
.ant-avatar-string {
  transform: scale(1) translate(-50%) !important;
}
@media screen and (max-width: 426px) {
  .meet-res {
    padding-top: 0px !important;
  }
}
.dovemed-card {
  padding: 24px 18px 12px 24px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #ccc;
  margin-bottom: 20px;

  .title {
    font-size: 18px;
    font-weight: bold;
    width: auto !important;
    height: auto !important;
  }

  p.title {
    margin-bottom: 12px;
  }

  .sub-title {
    font-size: 16px;
    font-weight: 500;
  }
}
.inline-justify {
  display: flex;
  justify-content: space-between;
}
.child {
  margin-top: 20px;
}
.post-head {
  display: flex;
  margin: 20px auto;
  .post-list-image {
    margin-right: 16px;
    margin-bottom: 15px;
  }
  .head-text {
    align-items: center;
  }
  p {
    margin-bottom: 2px;
  }
  .name {
    font-size: 18px;
    font-weight: bold;
    line-height: 22px;
    color: #333333 !important;
    margin-bottom: 2px;
    max-width: 100%;
    overflow: hidden;
    // padding:24px;
  }
  .hyper-link {
    color: rgb(48, 206, 230) !important;
    font-size: 14px;
    font-weight: bold;
    line-height: 17px;
    margin-top: 8px;
  }
  .location {
    font-size: 16px;
    line-height: 19px;
    margin-top: 5px;
    i {
      margin-right: 5px;
    }
  }
}
.user-profile {
  margin-bottom: 16px;
  cursor: pointer;
  width: 100%;
  display: flex;
  justify-content: space-between;

  .text-left {
    .name {
      display: flex;
      align-items: center;
      margin-left: 10px;
      margin-right: 20px;
      font-weight: 700;
      text-transform: capitalize;
    }
    .admin-tag {
      border-radius: 4px;
      background-color: rgba(0, 0, 0, 0.3);
      text-align: center;
      color: #ffffff;
      font-family: Lato;
      font-size: 10px;
      font-weight: bold;
      width: 100px;
      // margin: 0 auto;
      margin-left: 10px;
    }
  }
}
hr {
  margin-bottom: 16px;
  border: 0;
  clear: both;
  display: block;
  width: 96%;
  background-color: #e8e8e8;
  height: 1px;
}
.contact-card {
  .top {
    display: flex;
    align-items: center;
    margin-bottom: 24px;

    .text {
      line-height: 25px;
      font-size: 21px;
      font-weight: bold;
      color: #0f1734;
    }

    .beta-version {
      color: #ffffff;
      font-size: 10px;
      padding: 0px 8px;
      line-height: 17px;
      margin-bottom: 30px;
      margin-left: 5px;
    }
  }

  .mid {
    .description {
      color: #47556e;
      font-size: 16px;
      letter-spacing: 0;
      line-height: 24px;
      margin-bottom: 17px;

      .hyper-link {
        color: rgb(48, 206, 230) !important;
        text-decoration: underline;
        cursor: pointer;
      }
    }

    .info {
      color: #7a8ca3;
      font-size: 16px;
      font-style: italic;
      letter-spacing: 0;
      line-height: 24px;
    }
  }

  .bottom {
    margin-top: 24px;
    .dovemed-button {
      font-size: 14px;
      font-weight: 700;
      line-height: 24px;
      padding: 12px 24px;
      border-radius: 6px;
    }
  }
}
.circle-phone {
  display: flex;
  align-items: center;

  height: 40px;
  width: 40px;
  color: white;
  border-radius: 50%;
  justify-content: center;
  font-size: 27px;
}
.leftFooter {
  color: #647490 !important;
  font-size: 14px;
  line-height: 21px;
  a {
    color: #647490 !important;
    margin: auto 1px;
    &:hover {
      color: #647490 !important;
    }
  }
  p {
    color: #647490 !important;
  }
}
.home-tab {
  a {
    border-radius: 4px;
    padding: 8px !important;
    // margin-bottom: 10px;
  }
}
.box {
  width: 532px;
  position: absolute;
  padding: 24px;
  border-radius: 8px;
  z-index: 1;
}
.box1 {
  left: 110px;
  top: 100px;
}
.box2 {
  top: 100px;
  left: 260px;
}
.box3 {
  top: 60px;
  left: 40px;
}
.box4 {
  top: 50px;
  left: 10px;
}
.box5 {
  top: 60px;
  left: 40px;
}
.arrowPart {
  position: absolute;
  height: 22px;
  width: 22px;
  transform: rotate(45deg);
  top: -11px;
}
@media screen and (max-width: 768px) {
  .row {
    flex-direction: column-reverse;
  }
  .home-right-side {
    margin-bottom: 24px;
  }
  .m-mw-100 {
    max-width: 100% !important;
  }
  .pt-5 {
    padding-top: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/App/Home.vue